import { Popover } from '@chakra-ui/react';

import { Button, Typography } from 'shared';
import { Icon, iconNames } from 'shared_DEPRECATED/components/Icon';

export const JournalFilterAnchor = () => {
  return (
    <Popover.Trigger asChild>
      <Button variant="ghost">
        <Icon
          name={iconNames.controls}
          height="14px"
          width="14px"
          strokeWidth={0.2}
          stroke="var(--fgInteractive)"
          fill="var(--fgInteractive)"
        />
        <Typography color="blue" dataTestid="journal-sidebar-filters-button">
          Filters
        </Typography>
      </Button>
    </Popover.Trigger>
  );
};
